module.exports = __webpack_public_path__ + "static/media/PCI.86809e12.svg";